import loggingService from '../services/util/loggingService'
import dateService from '../services/util/dateService'

var isDebug = false
var path = '/ProjectShpoComment/'

function put (http, projectShpoCommentDto) {
    loggingService.log(isDebug, 'ProjectShpoComment Service', 'put')
    return http.put(`${path}`, projectShpoCommentDto)
}

function listByProjectId (http, projectId) {
    loggingService.log(isDebug, 'ProjectShpoComment Service', 'listByProjectId')
    return http.get(`${path}ListByProjectId?ProjectId=${projectId}`).then(response => {
        response.data.forEach(comment => {
            comment.createdDate = dateService.convertToDate(comment.createdDate)
        })
        return response
    })
}

function get (http, id) {
    loggingService.log(isDebug, 'ProjectShpoComment Service', 'get')
    return http.get(`${path}?id=${id}`)
}

function remove (http, id) {
    loggingService.log(isDebug, 'ProjectShpoComment Service', 'delete for : ' + id)
    return http.delete(path + `?id=${id}`)
}

export default {
    put: put,
    listByProjectId: listByProjectId,
    get: get,
    remove: remove
}



// WEBPACK FOOTER //
// ./src/services/projectShpoCommentService.js